import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad gäller för food truck och alkoholservering?";
const SHORT_ANSWER = "En food truck räknas som rörlig lokal och kräver särskild prövning. Många kommuner är restriktiva med alkohol från food truck.";

export const Route = createFileRoute("/fraga/food-truck-vad-galler")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad gäller för food truck och alkoholservering" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Du behöver tydlig serveringsyta vid varje tillfälle, livsmedelsregistrering och ofta tillfälligt tillstånd per evenemang. Få kommuner ger stadigvarande tillstånd till food trucks med alkohol."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/serveringstillstand-food-truck-guide", label: "Food truck och tillstånd" }}
      related={[{"to": "/fraga/hur-mycket-kostar-tillfalligt-tillstand", "label": "Vad kostar ett tillfälligt serveringstillstånd?"}, {"to": "/fraga/vad-ar-gardsforsaljning-2026", "label": "Vad är gårdsförsäljning enligt det nya regelverket 2026?"}, {"to": "/fraga/far-jag-ha-tillstand-utan-fysisk-lokal", "label": "Kan jag få serveringstillstånd utan fast lokal?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Alkohol i food truck 2026 – tillåtet? Så säger reglerna" },
      { name: "description", content: "Får du servera alkohol från food truck? Rörlig lokal kräver särskild prövning – se kraven, kommunernas praxis och vad som gäller 2026." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/food-truck-vad-galler" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/food-truck-vad-galler" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/food-truck-vad-galler",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad gäller för food truck och alkoholservering", url: "https://alkoholprovet.se/fraga/food-truck-vad-galler" },
      ]),
    ],
  }),
});
